import authorizedAxios from "../../helpers/authorizedAxios";

export const SET_STOCK_REPORT = "SET_STOCK_REPORT";
export const SET_STOCK_REPORT_LOADING = "SET_STOCK_REPORT_LOADING";
export const SET_STOCK_REPORT_ERROR = "SET_STOCK_REPORT_ERROR";
export const SET_CURRENT_STOCK = "SET_CURRENT_STOCK";
export const SET_CURRENT_STOCK_LOADING = "SET_CURRENT_STOCK_LOADING";
export const SET_CURRENT_STOCK_ERROR = "SET_CURRENT_STOCK_ERROR";
export const SET_STOCK_MATERIAL_CONSUMPTION = "SET_STOCK_MATERIAL_CONSUMPTION";
export const SET_STOCK_MATERIAL_CONSUMPTION_LOADING = "SET_STOCK_MATERIAL_CONSUMPTION_LOADING";
export const SET_STOCK_MATERIAL_CONSUMPTION_ERROR = "SET_STOCK_MATERIAL_CONSUMPTION_ERROR";

export const fetchStockMaterialUsage = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_STOCK_REPORT_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/stock-reports/material-usage", { params });
      dispatch({
        type: SET_STOCK_REPORT,
        data: response?.data?.data || null,
      });
      return response?.data?.data || null;
    } catch (error) {
      dispatch({
        type: SET_STOCK_REPORT_ERROR,
        error: error?.response?.data?.message || "Gagal mengambil laporan stock.",
      });
      return null;
    } finally {
      dispatch({ type: SET_STOCK_REPORT_LOADING, status: false });
    }
  };
};

export const fetchCurrentStock = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_CURRENT_STOCK_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/stock-reports/current-stock", { params });
      dispatch({
        type: SET_CURRENT_STOCK,
        data: response?.data?.data || null,
      });
      return response?.data?.data || null;
    } catch (error) {
      dispatch({
        type: SET_CURRENT_STOCK_ERROR,
        error: error?.response?.data?.message || "Gagal mengambil data sisa stock.",
      });
      return null;
    } finally {
      dispatch({ type: SET_CURRENT_STOCK_LOADING, status: false });
    }
  };
};

export const fetchStockMaterialConsumption = ({
  startDate,
  endDate,
  category = "all",
  unit = "all",
  groupBy = "material",
  drillDownCategory = "",
} = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_STOCK_MATERIAL_CONSUMPTION_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/stock-reports/material-consumption", {
        params: {
          start_date: startDate,
          end_date: endDate,
          category,
          unit,
          group_by: groupBy,
          drill_down_category: drillDownCategory || undefined,
        },
      });
      const data = response?.data?.data || null;
      dispatch({ type: SET_STOCK_MATERIAL_CONSUMPTION, data });
      return data;
    } catch (error) {
      dispatch({
        type: SET_STOCK_MATERIAL_CONSUMPTION_ERROR,
        error: error?.response?.data?.message || "Insight pemakaian material belum dapat dimuat.",
      });
      return null;
    } finally {
      dispatch({ type: SET_STOCK_MATERIAL_CONSUMPTION_LOADING, status: false });
    }
  };
};
